import DOMPurify from "dompurify";

export const ARTIFACT_REFERENCE =
  /^lawworks-artifact:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/** No generated code executes here; the iframe is a separate, script-free document. */
export function visualDocument(
  html: string,
  dark: boolean,
  scrollable = true,
): string {
  const safe = DOMPurify.sanitize(html, {
    WHOLE_DOCUMENT: true,
    FORBID_TAGS: [
      "script",
      "iframe",
      "object",
      "embed",
      "link",
      "meta",
      "base",
      "form",
      "a",
      "image",
      "use",
      "animate",
      "set",
      "foreignObject",
    ],
    FORBID_ATTR: [
      "src",
      "srcset",
      "href",
      "xlink:href",
      "action",
      "formaction",
      "poster",
      "background",
    ],
  });
  // Place the policy before all generated content. CSP also blocks CSS URLs/imports.
  return `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'none'; style-src 'unsafe-inline'; img-src 'none'; font-src 'none'; connect-src 'none'; media-src 'none'; frame-src 'none'; object-src 'none'; base-uri 'none'; form-action 'none'"><meta name="color-scheme" content="${dark ? "dark" : "light"}"><style>html{color-scheme:${dark ? "dark" : "light"};background:${dark ? "#10111b" : "#fff"};color:${dark ? "#e7e7ef" : "#20212a"};font:14px system-ui}body{margin:16px}svg,img{max-width:100%;height:auto}*{box-sizing:border-box}</style></head><body>${safe}<style>html{overflow:${scrollable ? "auto" : "hidden"}!important}</style></body></html>`;
}
